import { render } from "./SpikeMark.vue?vue&type=template&id=5401916e&scoped=true"
import script from "./SpikeMark.vue?vue&type=script&lang=js"
export * from "./SpikeMark.vue?vue&type=script&lang=js"

import "./SpikeMark.vue?vue&type=style&index=0&id=5401916e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5401916e"]])

export default __exports__